"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
Object.defineProperty(exports, "__esModule", { value: true });
var React = __importStar(require("react"));
function DropDownMultipleOption(_a) {
    var optionToCreate = _a.optionToCreate, onClick = _a.onClick, onKeyDown = _a.onKeyDown, index = _a.index, isSelected = _a.isSelected;
    return (React.createElement("div", { id: "option-".concat(index), onClick: function (e) { return onClick(e); }, onKeyDown: function (e) { return onKeyDown(e); }, role: "button", tabIndex: 0 },
        React.createElement("div", { className: "t2-checkbox" },
            React.createElement("input", { type: "checkbox", id: "option-".concat(index, "-checkbox"), readOnly: true, checked: isSelected }),
            React.createElement("label", { htmlFor: "option-".concat(index, "-checkbox") }, optionToCreate.dropdownLabel))));
}
exports.default = DropDownMultipleOption;
